import { FunctionComponent, ReactElement } from "react";

import { bridge } from "@multiweb/reactCore/bridge";
import { OWDataType } from "@multiweb/types/contracts";
import { IBigNumber } from "@multiweb/types/multiweb";

const { getFormattedNumberString } = bridge;

/**
 * Množina vstupních hodnot se odvíjí od funkcionality formátovací funkce
 * @see getFormattedNumberString
 */
export type NumberFormatterValue = string | IBigNumber | number | null | undefined;

export type NumberFormatterProps = {
    /** Potomci, kteří mají k dispozici zformátovanou hodnotu */
    children: (value: string) => ReactElement;
    /**
     * Formát aplikovaný na vstupní hodnotu
     * @see https://wiki-dokumentace/index.php?title=DisplayFormat
     */
    displayFormat?: string;
    /** Vstupní formátovaná hodnota */
    value: NumberFormatterValue;
    /** Měna, která se má v dané kultůře naformátovat. */
    currency?: string;
    /** Datový typ. */
    dataType?: OWDataType | string;
};

/**
 * Hook pro výpočet výsledné hodnoty
 * @param displayFormat Formát aplikovaný na vstupní hodnotu
 * @param value Vstupní formátovaná hodnota
 * @param currency Měna, která se má v dané kultůře naformátovat.
 * @param dataType Datový typ.
 * @returns Zformátovaná hodnota
 */
const useFormattedString: typeof getFormattedNumberString = (
    value,
    { displayFormat, currency, dataType },
) => getFormattedNumberString(value, { displayFormat, currency, dataType });

/** Komponenta pro převod číselné hodnoty na řetězcovou podle zadaného formátu */
export const NumberFormatter: FunctionComponent<NumberFormatterProps> = ({
    children,
    displayFormat,
    value,
    currency,
    dataType,
}) => children(useFormattedString(value, { displayFormat, currency, dataType }));
